module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/Quiz_2.3_9.f0a0c706.pdf";